import { withProgressIconStyles } from '@ps/common-features/components/request-status-badge/withProgressIconStyles'
import type { BadgeProps } from '@ps/ds/components/primitives/Badge/Badge'
import { Progress25 } from '@ps/ds/icons/Progress25'
import { Progress50 } from '@ps/ds/icons/Progress50'
import { ProgressDoneDuoTone } from '@ps/ds/icons/ProgressDoneDuoTone'
import { CircleX, type LucideIcon } from 'lucide-react'

type RequestStatusBadgeConfig = {
  icon: LucideIcon
  variant: NonNullable<BadgeProps['variant']>
}

export const REQUEST_STATUS_BADGE_CONFIG = {
  new: {
    icon: withProgressIconStyles(Progress25, 'text-emerald-500 -scale-x-100'),
    variant: 'outline',
  },
  in_progress: {
    icon: withProgressIconStyles(Progress50, 'text-emerald-500 -scale-x-100'),
    variant: 'outline',
  },
  completed: {
    icon: withProgressIconStyles(ProgressDoneDuoTone, 'text-emerald-500'),
    variant: 'success',
  },
  voided: { icon: CircleX, variant: 'fill' },
} satisfies Record<string, RequestStatusBadgeConfig>
